import CancellationFeeTemplate from "components/templates/SettingsTemplate/CancellationFeeTemplate"

const CancellationFee = () => (
  <CancellationFeeTemplate />
)

export default CancellationFee